/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type OnboardingOrgInviteQueryVariables = {
    queryInput: string;
    orgRelayId: string;
};
export type OnboardingOrgInviteQueryResponse = {
    readonly node: {
        readonly id: string;
        readonly orgPersonListPaginatedErrorable?: {
            readonly __typename: "GraphEntityError";
            readonly message: string | null;
        } | {
            readonly __typename: "OrgPersonListPaginated";
            readonly inputQuery: string | null;
            readonly searchPersons: ReadonlyArray<{
                readonly person: {
                    readonly primaryCalendarId: string;
                    readonly userId: string | null;
                    readonly personId: string;
                    readonly isYou: boolean;
                    readonly profile: {
                        readonly givenName: string | null;
                        readonly familyName: string | null;
                        readonly externalImageUrl: string | null;
                    } | null;
                };
            }> | null;
        } | {
            /*This will never be '%other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        } | undefined;
    } | null;
};
export type OnboardingOrgInviteQuery = {
    readonly response: OnboardingOrgInviteQueryResponse;
    readonly variables: OnboardingOrgInviteQueryVariables;
};



/*
query OnboardingOrgInviteQuery(
  $queryInput: String!
  $orgRelayId: ID!
) {
  node(id: $orgRelayId) {
    __typename
    id
    ... on Org {
      orgPersonListPaginatedErrorable(sortType: Status, sortDirection: Ascending, limit: 5, searchQuery: $queryInput) {
        __typename
        ... on GraphEntityError {
          message
        }
        ... on OrgPersonListPaginated {
          inputQuery
          searchPersons {
            person {
              primaryCalendarId
              userId
              personId
              isYou
              profile {
                givenName
                familyName
                externalImageUrl
              }
              id
            }
          }
        }
      }
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "orgRelayId"
    } as any, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "queryInput"
    } as any, v2 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "orgRelayId"
        } as any
    ], v3 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    } as any, v4 = [
        {
            "kind": "Literal",
            "name": "limit",
            "value": 5
        } as any,
        {
            "kind": "Variable",
            "name": "searchQuery",
            "variableName": "queryInput"
        } as any,
        {
            "kind": "Literal",
            "name": "sortDirection",
            "value": "Ascending"
        } as any,
        {
            "kind": "Literal",
            "name": "sortType",
            "value": "Status"
        } as any
    ], v5 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    } as any, v6 = {
        "kind": "InlineFragment",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
            }
        ],
        "type": "GraphEntityError",
        "abstractKey": null
    } as any, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "inputQuery",
        "storageKey": null
    } as any, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "primaryCalendarId",
        "storageKey": null
    } as any, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "userId",
        "storageKey": null
    } as any, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "personId",
        "storageKey": null
    } as any, v11 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isYou",
        "storageKey": null
    } as any, v12 = {
        "alias": null,
        "args": null,
        "concreteType": "UserProfile",
        "kind": "LinkedField",
        "name": "profile",
        "plural": false,
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "givenName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "familyName",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalImageUrl",
                "storageKey": null
            }
        ],
        "storageKey": null
    } as any;
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "OnboardingOrgInviteQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v3 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v4 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgPersonListPaginatedErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v7 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SearchPerson",
                                                    "kind": "LinkedField",
                                                    "name": "searchPersons",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "OrgPerson",
                                                            "kind": "LinkedField",
                                                            "name": "person",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v12 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "OrgPersonListPaginated",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v1 /*: any*/),
                (v0 /*: any*/)
            ],
            "kind": "Operation",
            "name": "OnboardingOrgInviteQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v2 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v5 /*: any*/),
                        (v3 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v4 /*: any*/),
                                    "concreteType": null,
                                    "kind": "LinkedField",
                                    "name": "orgPersonListPaginatedErrorable",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v6 /*: any*/),
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                (v7 /*: any*/),
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "SearchPerson",
                                                    "kind": "LinkedField",
                                                    "name": "searchPersons",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "OrgPerson",
                                                            "kind": "LinkedField",
                                                            "name": "person",
                                                            "plural": false,
                                                            "selections": [
                                                                (v8 /*: any*/),
                                                                (v9 /*: any*/),
                                                                (v10 /*: any*/),
                                                                (v11 /*: any*/),
                                                                (v12 /*: any*/),
                                                                (v3 /*: any*/)
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "type": "OrgPersonListPaginated",
                                            "abstractKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "type": "Org",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "393cdcf2a526cf8f39a070dc3f657e11",
            "id": null,
            "metadata": {},
            "name": "OnboardingOrgInviteQuery",
            "operationKind": "query",
            "text": "query OnboardingOrgInviteQuery(\n  $queryInput: String!\n  $orgRelayId: ID!\n) {\n  node(id: $orgRelayId) {\n    __typename\n    id\n    ... on Org {\n      orgPersonListPaginatedErrorable(sortType: Status, sortDirection: Ascending, limit: 5, searchQuery: $queryInput) {\n        __typename\n        ... on GraphEntityError {\n          message\n        }\n        ... on OrgPersonListPaginated {\n          inputQuery\n          searchPersons {\n            person {\n              primaryCalendarId\n              userId\n              personId\n              isYou\n              profile {\n                givenName\n                familyName\n                externalImageUrl\n              }\n              id\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"
        }
    } as any;
})();
(node as any).hash = '1a1240ac15a0b7879ef134dd6de0bf86';
export default node;
